const n={};function t(t){Object.assign(n,t)}export{t as addScaleCorrector,n as scaleCorrectors};
